import SimpleBar from 'simplebar';
import ResizeObserver from 'resize-observer-polyfill';
import _ from 'lodash';
import $ from "jquery";

import './../../scss/theme/components/anchor-navigation.scss';
import 'simplebar/dist/simplebar.css';

window.ResizeObserver = ResizeObserver;

let debug = false;

const stringToSlug = (str) => {
  if (!isNaN(str.charAt(0))){ //If is a number
    str = 'x' + str;
  }
  str = _.kebabCase(str
    .replace(/\u00AD/g, '') // Removes html entity &shy; from string without replacement
    .replace(/^\s+|\s+$/g, '')
    .toLowerCase()
  );
  // remove accents, swap ñ for n, etc
  var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆĞÍÌÎÏİŇÑÓÖÒÔÕØŘŔŠŞŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇğíìîïıňñóöòôõøðřŕšşťúůüùûýÿžþÞĐđßÆa·/_,:;";
  var to   = "AAAAAACCCDEEEEEEEEGIIIIINNOOOOOORRSSTUUUUUYYZaaaaaacccdeeeeeeeegiiiiinnooooooorrsstuuuuuyyzbBDdBAa------";
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }
  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
           .replace(/\s+/g, '-') // collapse whitespace and replace by -
           .replace(/-+/g, '-'); // collapse dashes

  return str;
}

/**
 * Helper func to get ce container itself or an existing wrapper
 */
function getCeSection(hash){
  let section = document.querySelector(hash);
  if(section && section.hasAttribute('data-ceId')){
    let ceEleId = section.getAttribute('data-ceId');
    section = document.getElementById(ceEleId);
  }
  return section;
}

window.addEventListener('DOMContentLoaded', () => {
  const scrollSpyNav = document.querySelector('.navbar-scrollspy');
  if(!scrollSpyNav) return false;

  const scrollSpyTitle = scrollSpyNav.querySelector('.navbar-title');
  const scrollSpyNavWrap = scrollSpyNav.querySelector('.navbar-nav');
  const scrollSpyNavWrapMobile = scrollSpyNav.querySelector('.navbar-mobile');
  const scrollSpyContainer = document.querySelector('.main-content');
  const headlines = scrollSpyContainer?.querySelectorAll('h2');
  const mainHeader = document.querySelector('.main-header');
  const navbarToggler = document.body.querySelector('.navbar-toggler');
  // if(scrollSpyContainer){
  //   scrollSpyContainer.setAttribute('data-upb-spy', 'scroll');
  // }else{
  //   document.body.setAttribute('data-upb-spy', 'scroll');
  // }

  let count = 0;
  if (headlines?.length) {
    for (const [index, headline] of Object.entries(headlines)) {
      if(!headline.getAttribute('data-scrollspy-disable')) {
        let navLinkText = !headline.getAttribute('data-scrollspy-text') ? headline.innerText : headline.getAttribute('data-scrollspy-text');

        let closestParent = headline.closest('.ce, .frame');
        if(closestParent) {
          let sectionId = stringToSlug(navLinkText);
          if(document.querySelector('#' + sectionId)){
            //already exists
            let duplicateId = 2;
            while(document.querySelector('#' + sectionId + '-' + duplicateId)){
              duplicateId++;
            }
            sectionId = sectionId + '-' + duplicateId;
          }
          if(closestParent.getAttribute('id')){ // Has already an id? like c12332
            const ceWrapper = document.createElement('div');
            ceWrapper.setAttribute('id', sectionId);
            ceWrapper.setAttribute('class', "nav-anchor-section");
            ceWrapper.setAttribute('data-ceId', closestParent.getAttribute('id'));
            //ceWrapper.innerHTML = closestParent.innerHTML;
            //closestParent.innerHTML = '';
            //closestParent.appendChild(ceWrapper);
            closestParent.parentNode.insertBefore(ceWrapper, closestParent);
            ceWrapper.appendChild(closestParent);
            closestParent = ceWrapper;
          }else{
            closestParent.setAttribute('id', sectionId);
          }
        }

        // Only build a sticky nav bar with at least 2 nav items
        if(headlines.length > 1){
          const navLink = document.createElement('a');
          navLink.setAttribute('class', 'nav-link');
          if(closestParent) {
              navLink.setAttribute('href', `#${closestParent.id}`);
          }
          navLink.innerHTML = navLinkText;
  
          const navItem = document.createElement('div');
          navItem.setAttribute('class', 'nav-item');
          navItem.appendChild(navLink);
          
          scrollSpyNavWrap.appendChild(navItem);

          if(count === 0 && scrollSpyTitle) {
            // Set mobile selector on first element
            scrollSpyTitle.setAttribute('href', navLink.href);
            scrollSpyTitle.innerHTML = navLink.innerHTML;
          }
        }
        count++;
      }
    }
  }

  if(count <= 1) {
    // Disables the mobils sticky nav
    scrollSpyNavWrapMobile.innerHTML = '';
    // Why not remove the mobile nav at all?
    const mobileSelectorNavWrapper = document.body.querySelector('.navbar-mobile');
    if(mobileSelectorNavWrapper){
      mobileSelectorNavWrapper.remove();
    }
  }

  // Init desktop sticky navigation:
  const createdStickyNav = initScrollSpy();
  if(createdStickyNav){
    window.addEventListener('resize', initScrollSpy);
    // Arrows of simplebar navigatin on overflow
    initSimpleBar();
    initArrowScroll();
  }

  // Init mobile select options navigation and lang switcher
  scrollspyLinkClick();

  // Page is loaded with an anchor
  if(count > 0) {
    if (location.hash) {
      let currentHash = location.hash;
      if (currentHash !== "") {
        // Let the client load first, so that rect and positions are accurate
        setTimeout(function(){
          scrollToAnchorHash(currentHash);
        }, 1000);
      }
    }
  }

  function initScrollSpy() {

    if(debug){
      console.log("initScrollSpy");
      $('.debug-line').remove();
    }
    // document.body.addEventListener('activate.bs.scrollspy', (event) => {
    //   //event.preventDefault(); // Catches the event and prevents further handling of other listeners (else underlying wrapper elements may get the click)
    //   setNavTitle(event.relatedTarget);
    // });
    //
    //
    // navStickyBar = new bootstrap.ScrollSpy($('body'), {
    //   target: '#main-scroll-nav',
    //   smoothScroll: true,
    //   rootMargin: `-${scrollSpyNavHeight}px 0px`,
    //   threshold: getThresholdValues()
    // });
    
    // const observer = new IntersectionObserver((entries) => {
    //   for(const entry of entries)
    //     if(entry.isIntersecting)
    //       label.innerHTML = entry.target.innerText;
    //   },{
    //   rootMargin: "-50% 0px"
    // });
    // for (let i = 0; i < sections.length; i++){
    //   observer.observe(sections[i]);
    // }

    let navbarLinks = document.querySelectorAll("nav a.nav-link");
    if(navbarLinks.length == 0){
      // No sticky bar, no work here to do
      return false;
    }

    const scrollSpyNavHeight = scrollSpyNav.offsetHeight;

    let mainContentScrollStart = 0;
    let mainContentWrapper = document.querySelector('main.main-content');
    if(mainContentWrapper){
      mainContentScrollStart += mainContentWrapper.offsetTop;
    }

    // 130 + 120 + 106 = 356 header, stickynav, breadcrumbs
    //console.log("Offset", mainContentScrollStart); 

    // First element
    // 356 + 80 margin => 1-sectin starts at = 436

    // let lastActive;
    if(debug){
      $('body').append('<div id="scroll-bar-debug" class="debug-line" style="position: absolute; top: 356px; left: 0; width: 100%; height: 4px; background: red;z-index: 9999"></div>');
      $('body').append('<div id="scroll-bar-debug2" class="debug-line" style="position: absolute; top: '+mainContentScrollStart+'px; left: 0; width: 100%; height: 4px; background: green;z-index: 9999">'+mainContentScrollStart+'</div>');
      
      navbarLinks.forEach(link => {
        let section = getCeSection(link.hash);
        let sectionScrollStart = getAbsoluteTop(section); //mainContentScrollStart + getAbsoluteTop(section);
        let sectionScrollEnd = sectionScrollStart + getAbsoluteHeight(section);

        $('<div class="debug-line" style="position: absolute; top: '+sectionScrollStart+'px; left: 0; width: 100%; height: 4px; background: yellow;z-index: 9999">section ' + link.hash + ' (Start: ' + sectionScrollStart +')'+'</div>')
        .appendTo('body');
        $('<div class="debug-line" style="position: absolute; top: '+sectionScrollEnd+'px; left: 0; width: 100%; height: 4px; background: blue;z-index: 9999; text-align: right">section ' + link.hash + ' (End: ' + sectionScrollEnd +')'+'</div>')
        .appendTo('body');
      });
    }

    function isNavActive(hash){
      if( ! hash){
        return false;
      }
      let scrollPos = window.scrollY;
      let stickOffset = scrollSpyNavHeight;
      let scrollView = scrollPos + stickOffset;
      let section = getCeSection(hash);
      let sectionScrollStart = getAbsoluteTop(section); //mainContentScrollStart + getAbsoluteTop(section);
      let sectionScrollEnd = sectionScrollStart + getAbsoluteHeight(section);
      if(debug){
        console.log("Section", section);
        console.log("SectionOffsetTop", section.offsetTop);
        console.log("SectionStartsX", sectionScrollStart);
        console.log("SectionEndsX", sectionScrollEnd);
      }
      return (scrollView >= sectionScrollStart && scrollView < sectionScrollEnd );
    }

    function isNavPrev(hash){
      if( ! hash){
        return false;
      }
      let scrollPos = window.scrollY;
      let stickOffset = scrollSpyNavHeight;
      let scrollView = scrollPos + stickOffset;
      let section = getCeSection(hash);
      let sectionScrollStart = getAbsoluteTop(section); //mainContentScrollStart + getAbsoluteTop(section);
      let sectionScrollEnd = sectionScrollStart + getAbsoluteHeight(section);
      return (scrollView >= sectionScrollEnd);
    }

    function toogleNavActiveClass(e){
      let scrollPos = window.scrollY;
      let stickOffset = scrollSpyNavHeight;
      let scrollView = scrollPos + stickOffset;

      if(debug){
        let debugBar = $('#scroll-bar-debug');
        $(debugBar).css('top', scrollView + 'px');
        console.log("Scroll", scrollPos);
        console.log("ScrollOffset", stickOffset);
        console.log("ScrollWithOffset", scrollView);
      }

      if(globalThis.lastScrollToAnchor){
        let intersects = isNavActive(globalThis.lastScrollToAnchor.hash);
        if (intersects || ! mainHeader.classList.contains('scroll-click')) {
          // Continue active highlighting if intersects or timeout/scrolled to other region
          globalThis.lastScrollToAnchor = false;
          toogleNavActiveClass(e);
        }else{
          if( globalThis.lastScrollToAnchor && ! globalThis.lastScrollToAnchor.classList.contains('active')){
            globalThis.lastScrollToAnchor.classList.add("active");
            setNavTitle(globalThis.lastScrollToAnchor);
            
            navbarLinks.forEach(link => {
              if(link.hash != globalThis.lastScrollToAnchor.hash){
                link.classList.remove("active");
              }
            });
          }
        }
        // Stop active highlighting while scrolling to anchor (by click)
        return;
      }

      let newActive; // Delay set class active; Prevents duplicated active sets when rect overlap so it could be two active
      let prevNavItem;// = navbarLinks[0]; // Better use empty list so that from top it could be an intro section without any subheadline (like /person/123 with Über xy)
      navbarLinks.forEach(link => {
        let intersects = isNavActive(link.hash);
        if (intersects) {
          newActive = link;
        } else {
          if(isNavPrev(link.hash)){
              prevNavItem = link;
          }
        }
      });
      // No intersection, then use prev item (Means one headline rules all underling onces till next headline occures)
      if( ! newActive){
        newActive = prevNavItem;
      }

      // Send html class manipulation once; Else remove/add flickers in cases where no section is found and so the prev should be active
      navbarLinks.forEach(link => {
        if (link == newActive) {
          if( ! link.classList.contains("active")){
            link.classList.add("active");
            setNavTitle(link);
          }
        } else {
          if(link.classList.contains("active")){
            link.classList.remove("active");
          }
        }
      });
      
      return true;
    }

    window.addEventListener("scroll", toogleNavActiveClass);
    toogleNavActiveClass();
    return true;
    // On page load we can have a scroll init in mid area without a headline. So activate the nav once before scrolled over
    // if( ! lastActive){
    //   navbarLinks.forEach(link => {
    //     let scrollPos = window.scrollY;
    //     let stickOffset = scrollSpyNavHeight;
    //     let scrollView = scrollPos + stickOffset;
    //     let section = getCeSection(link.hash);
    //     let sectionScrollStart = mainContentScrollStart + getAbsoluteTop(section);
    //     if (scrollView >= sectionScrollStart) {
    //       lastActive = link;
    //     }
    //   });
    //   if( ! lastActive){
    //     lastActive = navbarLinks[0];
    //   }
    //   lastActive.classList.add("active");
    //   setNavTitle(lastActive);
    // }
  }

  /** 
   * Mobile: Sets the navagation title for the navigation-select-form
   */
  function setNavTitle(element) {
    //console.log(element);
    // element = $(element).parent('div.nav-item')[0];
    // console.log(element);
    if(scrollSpyTitle.innerText != element.innerText){
      scrollSpyTitle.innerText = element.innerText;
    }
    if(scrollSpyTitle.href != element.hash){
      scrollSpyTitle.setAttribute('href', element.hash);
    }

    if(window.innerWidth >= '576') {
      const simplebarContentWrapper = document.querySelector('.simplebar-content-wrapper');
      if(simplebarContentWrapper){
        const elementLeft = element.offsetLeft;
        const containerLeft = simplebarContentWrapper.offsetLeft;        
        let alignCenter = (simplebarContentWrapper.offsetWidth - element.offsetWidth )/ 2;
        simplebarContentWrapper.scrollTo({ left: elementLeft - containerLeft - alignCenter, behavior: 'smooth' });
      }
    }
  }


  /**
   * Desktop: Scrolls smoothly to an anchor + margin distance
   * Mobile: Scrolls to anchor when selecting a new option in the navigation-select-form
   */
  function scrollspyLinkClick() {
    const mobileSelectorNav = document.body.querySelector('.navbar-title');
    if(mobileSelectorNav){
      const mobileSelectorNavWrapper = document.body.querySelector('.navbar-mobile');
      var openSelectBox = (e) => {
        if (navbarToggler && window.getComputedStyle(navbarToggler).display !== 'none') navbarToggler.click();
        e.preventDefault();
      };
      mobileSelectorNav.addEventListener('click', openSelectBox);
      mobileSelectorNavWrapper.addEventListener('click', openSelectBox);

      let mobileNavPopover = document.getElementById('navbarScroll-0');
      // Close an open selectbox on scroll and outside click/blur/unfocus
      let unfocusHandler = false;
      let onScrollHandler = false;
      let onSafariHandler = false;

      let handlerFunc = (e) => { 
        // $(mobileNavPopover).collapse('hide'); 
        const collapsebleEle = bootstrap.Collapse.getInstance(mobileNavPopover);
        collapsebleEle.hide();
      };

      // Safari does not trigger (un)focus events on click = https://github.com/reactstrap/reactstrap/issues/1428
      // So trigger manual
      let safariOnClickDoBlur = (e) => {
        const isClickInside = navbarToggler.contains(e.target);
        if ( ! isClickInside) {
          handlerFunc();
        }
      };

      mobileNavPopover.addEventListener("shown.bs.collapse", (e) => {
        unfocusHandler = mobileNavPopover.addEventListener("blur", handlerFunc);
        onScrollHandler = window.addEventListener("scroll", handlerFunc);
        onSafariHandler = document.addEventListener("click", safariOnClickDoBlur);
      });

      mobileNavPopover.addEventListener("hide.bs.collapse", (e) => {
        if(unfocusHandler){
          mobileNavPopover.removeEventListener("blur", handlerFunc);
          unfocusHandler = false;
        }
        if(onScrollHandler){
          window.removeEventListener("scroll", handlerFunc);
          onScrollHandler = false;
        }
        if(onSafariHandler){
          document.removeEventListener('click', safariOnClickDoBlur);
          onSafariHandler = false;
        }
      });


    }
    const responsiveNavItems = [].slice.call(
      document.querySelectorAll('.navbar-nav-scroll .nav-link')
    );
    // responsiveNavItems.push(
    //   document.body.querySelector('.navbar-title')
    // );
    responsiveNavItems.map(function (responsiveNavItem) {
      responsiveNavItem.addEventListener('click', (event) => {
        scrollToAnchorHash(event.target.hash);
        event.preventDefault();
      });
    })
  }

  /**
   * Scroll smooth to anchor hash position with offsets 
   */
  function scrollToAnchorHash(hash){
    if (hash !== "") {
      // console.log("Scroll to ",  hash);
      const anchor = getCeSection(hash);
      const anchorPos = getAbsoluteTop(anchor);
      const scrollSpyNavHeight = scrollSpyNav.offsetHeight;
  
      // Block nav-hide-callback
      const mainHeader = document.querySelector('.main-header');
      mainHeader.classList.add('scroll-click');
      globalThis.lastScrollToAnchor = document.querySelector('.nav-link[href="#'+hash+'"]');
      globalThis.lastScrollToAnchorPos = anchorPos - scrollSpyNavHeight;

      scrollTo(
        globalThis.lastScrollToAnchorPos,
        function(){
          //unblock nav-hide-callback
          mainHeader.classList.remove('scroll-click');
        }
      );

      if (history.pushState) {
        history.pushState(null, null, hash);
      } else {
        window.location.hash = hash;
      }
    }

    if(globalThis.lastScrollToAnchor){
      setNavTitle(globalThis.lastScrollToAnchor);
      if (navbarToggler && window.getComputedStyle(navbarToggler).display !== 'none') navbarToggler.click();
    }
  }

  /**
   * Handles arrows on navigation content overflow
   */
  function initArrowScroll() {
    if(debug){
      console.log("Arrow scroll init");
    }
    //if simplebar-content-wrapper has overflow, then add button to scroll vertically
    const simplebarContentWrapper = document.querySelector('.simplebar-content-wrapper');
    if(simplebarContentWrapper) {
      const navbarNavScrollButtonLeft = document.querySelector('.navbar-nav-scroll-button-left');
      const navbarNavScrollButtonRight = document.querySelector('.navbar-nav-scroll-button-right');

      navbarNavScrollButtonLeft.addEventListener('click', () => {
        simplebarContentWrapper.scrollBy({ left: -200, behavior: 'smooth' });
      });
      navbarNavScrollButtonRight.addEventListener('click', () => {
        simplebarContentWrapper.scrollBy({ left: 200, behavior: 'smooth' });
      });

      // Check if scroll is at the end of the container
      function disableButtons() {
        // Left button
        if (simplebarContentWrapper.scrollLeft === 0) {
          navbarNavScrollButtonLeft.setAttribute('disabled', true);
        } else {
          navbarNavScrollButtonLeft.removeAttribute('disabled');
        }
        // Right button
        if (simplebarContentWrapper.scrollLeft >= simplebarContentWrapper.scrollWidth - simplebarContentWrapper.clientWidth - 1) {
          navbarNavScrollButtonRight.setAttribute('disabled', true);
        } else {
          navbarNavScrollButtonRight.removeAttribute('disabled');
        }
      }

      function showHideButtons(){
        const navbarNavScrollButtons = document.querySelector('.navbar-nav-scroll-buttons');
        let currentStateShow = ! navbarNavScrollButtons.hasAttribute('hidden');
        let avaibleWidth = simplebarContentWrapper.clientWidth;
        if(currentStateShow){
          avaibleWidth += navbarNavScrollButtons.clientWidth;
        }
        let showButtons = (simplebarContentWrapper.scrollWidth > avaibleWidth);

        // Avoids to manipulate DOM by spamming (Change apply only once)
        if(showButtons){
          if(navbarNavScrollButtons.hasAttribute('hidden')){
            navbarNavScrollButtons.removeAttribute('hidden');
            disableButtons(); // Check if new limits should disable left/right buttons
          }
        }else{
          if( ! navbarNavScrollButtons.hasAttribute('hidden')){
            navbarNavScrollButtons.setAttribute('hidden', true);
            disableButtons(); // Check if new limits should disable left/right buttons
          }
        }
      }

       // Check if new limits should disable left/right buttons
      simplebarContentWrapper.addEventListener('scroll', disableButtons);

      //window.addEventListener('resize', showHideButtons);
      // Not only observes window resize but also when the navigation bar shrinks because of menu buttons are integrated on the right side
      new ResizeObserver(showHideButtons).observe(simplebarContentWrapper);

      // Init calls
      showHideButtons();
      disableButtons();
    }

  }

  /**
   * Helper for bootstraps scrollspy threshold default values
   * @see https://getbootstrap.com/docs/5.2/components/scrollspy/#options
   * @deprecated
   */
  function getThresholdValues() {
    let values = [];
    for(let i = Number(0); i <= 1; i += 0.1) {
      values.push(parseFloat(Number.parseFloat(i).toFixed(1)))
    }
    return values;
  }

  /**
   * SimpleBar is used to hide the browsers scroll bar but still allow scrolling / or with arrows
   */
  function initSimpleBar() {
    const scrollSpyNavWrap = scrollSpyNav.querySelector('.navbar-nav');
    if(scrollSpyNavWrap){
      let bar = SimpleBar.instances.get(scrollSpyNavWrap);
      if(!bar){
        if(debug){
          console.log("Init simple bar");
        }
        new SimpleBar(scrollSpyNavWrap 
          // ,{
          //   autoHide: false,
          //   forceVisible: 'x',
          //   clickOnTrack: false,
          // }
        );
      }
      // Update simplebar
      // todo: https://github.com/Grsmto/simplebar/tree/master/packages/simplebar
    }
  }

  /**
   * Gets element height with border, padding and margin (Equal to jquerys outerHeight(true) but in pure js)
   */
  function getAbsoluteHeight(el) {
    // Get the DOM Node if you pass in a string
    el = (typeof el === 'string') ? document.querySelector(el) : el;

    if(! el){
      return 0;
    }
  
    var styles = window.getComputedStyle(el);
    var marginTop = parseFloat(styles['marginTop']);
    var marginBottom = parseFloat(styles['marginBottom']);
    if(!marginTop){
      // Add space to top, so that the anchor jumps dont lay directly 1px under the sticky bar
      if(marginBottom){
        marginTop = marginBottom;
      }else{
        marginTop = 200;
      }
    }
    var margin = marginTop / 2 + marginBottom / 2; // Divide by 2 because margin is intersected by two sections. So use the center
  
    return Math.ceil(el.offsetHeight + margin);
  }

  /**
   * Gets element top with margin or padding offsets
   */
  function getAbsoluteTop(el) {
    // Get the DOM Node if you pass in a string
    el = (typeof el === 'string') ? document.querySelector(el) : el; 

    if(! el){
      return 0;
    }
  
    var styles = window.getComputedStyle(el);
    var marginTop = parseFloat(styles['marginTop']);
    if(!marginTop){
      var paddingTop = parseFloat(styles['paddingTop']);
      if(!paddingTop){
        var marginBottom = parseFloat(styles['marginBottom']);
        // Add space to top, so that the anchor jumps dont lay directly 1px under the sticky bar
        if(! marginBottom){
          var paddingBottom = parseFloat(styles['paddingBottom']);
          if(paddingBottom){
            marginTop = paddingBottom;
          }else{
            marginTop = 200;
          }
        }else{
          marginTop = marginBottom;
        }
      }else{
        // paddingTop is added to el.top already
        marginTop = 0;
      }
    }
  
    return Math.ceil(getAbsoluteBoundingRect(el).top - marginTop / 2); // Divide by 2 because margin is intersected by two sections. So use the center
  }

  /**
   * scrollTo but with callback function
   */
  let callByTimeout;
  let onScroll;
  function scrollTo(top, callback) {
    //old timeout?
    if(callByTimeout){
      clearTimeout(callByTimeout);
      callByTimeout = undefined;
    }
    if(onScroll){
      window.removeEventListener('scroll', onScroll);
      onScroll = undefined;
    }

    // If scroll is interrupted
    callByTimeout = setTimeout(() => {
      if(onScroll){
        window.removeEventListener('scroll', onScroll);
        onScroll = undefined;
      }
      callByTimeout = undefined;
      callback();
    }, 950);

    onScroll = function () {
      let newScrollPos = window.scrollY;
      if (newScrollPos === top) {
        if(callByTimeout){
          clearTimeout(callByTimeout);
          callByTimeout = undefined;
        }
        callByTimeout = undefined;
        window.removeEventListener('scroll', onScroll);
        callback();
      }
    };
    window.addEventListener('scroll', onScroll);

    // Check if already on point
    onScroll();

    window.scrollTo({
        top: top,
        behavior: 'smooth'
    })
  }

  /**
   * Get absolute y position on page regarding its nested (relative) elements
   * @see https://gist.github.com/rgrove/5463265
   * @returns Promise
   */
  function getAbsoluteBoundingRect (el) {
    var doc  = document,
        win  = window,
        body = doc.body,

        // pageXOffset and pageYOffset work everywhere except IE <9.
        offsetX = win.pageXOffset !== undefined ? win.pageXOffset :
            (doc.documentElement || body.parentNode || body).scrollLeft,
        offsetY = win.pageYOffset !== undefined ? win.pageYOffset :
            (doc.documentElement || body.parentNode || body).scrollTop,

        rect = el.getBoundingClientRect();

    // var elementBounds = asyncGetBoundingClientRectUsingIO(el);

    if (el !== body) {
        var parent = el.parentNode;

        // The element's rect will be affected by the scroll positions of
        // *all* of its scrollable parents, not just the window, so we have
        // to walk up the tree and collect every scroll offset. Good times.
        while (parent !== body) {
            offsetX += parent.scrollLeft;
            offsetY += parent.scrollTop;
            parent   = parent.parentNode;
        }
    }

    return {
        bottom: rect.bottom + offsetY,
        height: rect.height,
        left  : rect.left + offsetX,
        right : rect.right + offsetX,
        top   : rect.top + offsetY,
        width : rect.width
    };
  }

  /**
   * Two diffrent approaches to get element bounds
   * The result are diff. on page load - Here the new IntersectionObserver is more accurate
   */
  function asyncGetBoundingClientRectUsingIO(element) {
    let observerOptions = {
        rootMargin: '0px',
        threshold: .25,
    };
    return new Promise(function (resolve) {
      var observer = new IntersectionObserver(function (entries) {
        observer.disconnect();
        resolve(entries[0].boundingClientRect);
      }, observerOptions);
      observer.observe(element);
    });
  }

  function asyncGetBoundingClientRectUsingGBCR(element) {
    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        var rect = element.getBoundingClientRect()
        resolve(rect)
      })
    });
  }

});
